module.exports = __webpack_public_path__ + "static/media/heroBg.66fec2bb.jpg";